document.addEventListener('DOMContentLoaded', function () {
  const parallaxElements = document.querySelectorAll('.parallax');

  if (!parallaxElements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let ticking = false;

  function updateParallax() {
    parallaxElements.forEach(function (parallax) {
      const container = parallax.closest('.parallax__container');

      if (!container) return;

      const rect = container.getBoundingClientRect();

      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      const movement = rect.top * -0.12;

      parallax.style.setProperty(
        'background-position',
        `center calc(50% + ${movement}px)`,
        'important'
      );
    });

    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    },
    { passive: true }
  );

  window.addEventListener('resize', updateParallax);

  updateParallax();
});